export class SkinnedMeshSprite3DShaderDeclaration {
}
